import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from '@material-ui/core';

import { t } from '~/helpers';

import { canURL } from '~/helpers';

import { recordFiltering } from '~/store/modules/cadastrousuariomaster/actions';

import { Form } from '..';

import { ADM, GFE, GFO, GFU, SERVICE_DESK, GPPEM, GPPE } from '~/constants/perfil';

export default function Heading() {
  //const Heading = React.memo(() => {

  const { profile } = useSelector((state) => state.user);

  const permission = canURL();


  const dispatch = useDispatch();

  const [modal, setModal] = React.useState(false);

  const [habAlterar, setHabAlterar] = useState(false);

  const tabsRef = React.useRef(null);

  const { params } = useSelector((state) => state.cadastrousuariomaster);


  useEffect(() => {
    let mounted = true;
    //buttons = buttons.slice(0);
    if (mounted) {
      //switch (profile.glousuariotipo) {       
      switch (profile.gloperfilid) {
        case ADM:
        case GFU:
        case GFO:
        case GFE:
        case SERVICE_DESK:
        case GPPEM:
        case GPPE:
          //setHabAlterar(true);
          if (!permission.update) {
            setHabAlterar(false)
          } else {
            setHabAlterar(true)
          }
          break;
        default:
          setHabAlterar(false);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);


  // open Modal Tabs
  const handleOpenTabs = React.useCallback(() => {
    setModal(true);
  }, []);

  // close Modal Tabs
  const handleCloseModal = React.useCallback(() => {
    setModal(false);
    dispatch(recordFiltering(params));
  }, [params]);

  React.useEffect(() => {
    if (modal) tabsRef.current.openModal();
  }, [modal]);

  return (
    <>
      {(habAlterar) ?
        <Button variant="contained" color="primary" onClick={handleOpenTabs}>
          {t('s.geral.botaoincluir')}
        </Button> : ''}

      {modal && <Form ref={tabsRef} onCloseModal={handleCloseModal} />}
    </>
  );
};

